const updateUserSalary = async (token: string, userId: string, salary: number) => {
	const response = await fetch(`${process.env.REACT_APP_BASE_API}/users/update-salary`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`
		},
		body: JSON.stringify({ userId, newSalary: salary })
	});

	return response.json();
};

export default updateUserSalary;
